import './App.scss';
import React, {useEffect, useState} from "react";
import {BrowserRouter, HashRouter, Navigate, Route, Routes} from 'react-router-dom';
import Navbar from "./layouts/navbar";
import Footer from "./layouts/footer";
import Login from "./pages/login";
import OpenAppointments from "./pages/openAppointments";
import {ToastContainer} from "react-toastify";
import 'react-toastify/dist/ReactToastify.css';
import {RouteData} from "./router/index";
import ResetPassword from "./pages/resetPassword";
import SubmitPassword from "./pages/resetPassword/partial/submitPassword";
import {AES, enc} from "crypto-js";
import {useStateValue} from "./states/StateProvider";
import packageJson from "../package.json";

function App() {

    const [{secretKey}] = useStateValue();
    let user=''

    try {
        const decryptedBytes = localStorage.getItem('user')?AES.decrypt(localStorage.getItem('user'), secretKey):false;
        user=JSON.parse(decryptedBytes.toString(enc.Utf8))
    }
    catch (e){
        window.localStorage.removeItem('user')
    }
    useEffect(() => {
        // Note: Primary version checking now happens in public/index.html BEFORE React loads
        // This is a safety fallback in case the inline script doesn't execute
        const cachedVersion = localStorage.getItem('appVersion');

        if (cachedVersion !== packageJson.version) {
            console.warn('[App.js Fallback] Version mismatch detected in React - clearing cache');

            // Store user data temporarily
            const userData = localStorage.getItem('user');
            const loginTimestamp = localStorage.getItem('loginTimestamp');

            // Clear all caches
            if ('caches' in window) {
                caches.keys().then((names) => {
                    names.forEach(name => {
                        caches.delete(name);
                    });
                });
            }

            // Clear localStorage but preserve session
            localStorage.clear();

            // Restore critical data
            if (userData) {
                localStorage.setItem('user', userData);
            }
            if (loginTimestamp) {
                localStorage.setItem('loginTimestamp', loginTimestamp);
            }
            localStorage.setItem('appVersion', packageJson.version);

            // Reload only if this was a version change (not first visit)
            if (cachedVersion !== null) {
                window.location.reload();
            }
        }
    }, []);

    return (
        <div className="App">
            <BrowserRouter>
                <Navbar/>
                <Routes>
                    <Route path='*' exact element={<Navigate to="/"/>}/>
                    {
                        RouteData.map(route => (
                            <Route key={route.id} path={route.path}
                                   element={user ? route.component : <Navigate to={route.redirection}/>}/>
                        ))
                    }
                    <Route path="/anmeldung" element={!user ? <Login/> : <Navigate to="/"/>}/>
                    <Route path="/open-appointments" element={user ? <OpenAppointments/> : <Navigate to="/anmeldung"/>}/>
                    <Route path="/reset-password" element={!user ?<ResetPassword/>:<Navigate to="/"/>}/>
                    <Route path="/reset-password/:email/:token" element={!user ?<SubmitPassword/>:<Navigate to="/"/>}/>
                    {/*<Route path="/registrieren" element={!user ? <Register/> : <Navigate to="/"/>}/>*/}
                </Routes>
                <Footer/>
            </BrowserRouter>
            <ToastContainer/>
        </div>
    );
}

export default App;
